import React, {useEffect, useState} from 'react'
import {Card, CardBody, CardHeader, Col, Container, Row} from 'reactstrap'
import withRouter from "../.././components/withRouter";
import TableContainer from "../.././components/TableContainerReactTable";
import AddEditAdvertiserModal from "./AddEditAdvertiserModal";
import { getAdvertisers } from '../../api/advertiserApi';
import { Advertiser } from '../../types/advertiser';
import { cnpjMask } from '../../utils';

const Index = (props: any) => {
    const [data, setData] = useState<Advertiser[]>([]);
    const [dataToEdit, setDataToEdit] = useState<Advertiser | null>(null);
    const [loading, setLoading] = useState<boolean>(true);
    const [isAddModalOpen, setIsAddModalOpen] = useState<boolean>(false);

    useEffect(() => {
        // Lista os publishers cadastrados na tabela
        getAdvertisers().then((res) => {
            setData(res);
        }).finally(() => {
            setLoading(false);
        });
    }, []);

    const toggleAddModal = () => {
        setIsAddModalOpen(!isAddModalOpen);
    };

    const handleUpdateData = (newData: Advertiser) => {
        const updatedData = data.map((item) => {
            if (item.id === newData.id) {
                return newData;
            }
            return item;
        });
        setData(updatedData);
    };

    const handleAddData = (newData: Advertiser) => {
        setData([...data, newData]);
    };

    const dateFormatOptions: Intl.DateTimeFormatOptions = {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        second: 'numeric',
        timeZoneName: 'shortOffset',
    };

    const columns = [
        {
            header: "#",
            cell: (cell: any) => {
                return (
                    <span className="fw-semibold">{cell.getValue()}</span>
                );
            },
            accessorKey: "id",
            enableColumnFilter: false,
            enableSorting: true,
        },
        {
            header: "Nome",
            accessorKey: "name",
            enableColumnFilter: false,
            enableSorting: true,
        },
        {
            header: "CNPJ",
            accessorFn: (row: any) => {
                return row.cnpj ? cnpjMask(row.cnpj) : '-';
            },
            enableColumnFilter: false,
            enableSorting: true,
        },
        {
            header: "Campanhas",
            accessorKey: "campaigns.length",
            enableColumnFilter: false,
            enableSorting: true,
        },
        {
            header: "Usuários",
            accessorKey: "users.length",
            enableColumnFilter: false,
            enableSorting: true,
        },
        {
            header: "Criado em",
            accessorFn: (row: any) => {
                const date = new Date(row.createdAt);
                return date.toLocaleDateString('pt-BR', dateFormatOptions);
            },
            enableColumnFilter: false,
            enableSorting: true,
        },
        {
            header: "Atualizado em",
            accessorFn: (row: any) => {
                const date = new Date(row.updatedAt);
                return date.toLocaleDateString('pt-BR', dateFormatOptions);
            },
            enableColumnFilter: false,
            enableSorting: true,
        },
        {
            header: "Actions",
            cell: (cell: any) => {

            },
            enableColumnFilter: false,
        },
    ];

    document.title = "Anunciantes | Ad Pulse";
    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <Row>
                        <Col lg={12}>
                            <Card>
                                <CardHeader>
                                    <Row className="g-4 align-items-center">
                                        <div className="col-sm">
                                            <h5 className="card-title mb-0">Anunciantes</h5>
                                        </div>
                                        <div className="col-sm-auto">
                                            <button
                                                type="button"
                                                className="btn btn-success add-btn me-1"
                                                id="create-btn"
                                                onClick={() => {
                                                    setDataToEdit(null);
                                                    toggleAddModal();
                                                }}
                                            >
                                                <i className="ri-add-line align-bottom me-1"></i> Adicionar advertiser
                                            </button>
                                        </div>
                                    </Row>
                                </CardHeader>
                                <CardBody>
                                    {!loading ? <TableContainer
                                            divClass="table-responsive"
                                            columns={(columns || [])}
                                            data={(data || [])}
                                            isGlobalFilter={true}
                                            customPageSize={30}
                                            SearchPlaceholder='Procurar...'
                                        /> :
                                        <div className="text-center">
                                            <div className="spinner-border text-primary" role="status">
                                                <span className="visually-hidden">Carregando...</span>
                                            </div>
                                        </div>}

                                    <AddEditAdvertiserModal
                                        advertiser={dataToEdit}
                                        isOpen={isAddModalOpen}
                                        toggle={toggleAddModal}
                                        onAddData={handleAddData}
                                        onUpdateData={handleUpdateData}
                                    />
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    )
}

export default withRouter(Index);